import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArchivedClients from '../components/Client/ArchivedClients';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`archived-tabpanel-${index}`}
      aria-labelledby={`archived-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `archived-tab-${index}`,
    'aria-controls': `archived-tabpanel-${index}`,
  };
}

export default function ArchivedRecords() {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="container mx-auto px-6 py-8 overflow-y-scroll">
      <div className="bg-white rounded-lg shadow-lg p-6 min-h-[calc(100vh-4rem)]">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          {/* Header Section */}
          <div className="bg-white shadow">
            <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between items-start">
                {/* Buttons on the left */}
                <div className="flex flex-col space-y-4">
                  {/* Primary Actions */}
                  <div className="flex space-x-4">
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: 'none',
                        fontWeight: 700,
                        minWidth: '160px',
                        backgroundColor: '#2196f3',
                        '&:hover': {
                          backgroundColor: '#1976d2'
                        }
                      }}
                      onClick={() => navigate('/')}
                    >
                      Back to Home
                    </Button>
                  </div>
                </div>

                {/* Title on the right */}
                <div className="text-right">
                  <Typography 
                    variant="h3" 
                    component="h1" 
                    gutterBottom
                    sx={{
                      fontFamily: 'Roboto',
                      fontWeight: 800,
                      fontSize: '2.5rem',
                      color: '#1a365d',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Archived Records
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs Section */}
          <Paper sx={{ width: '100%', mt: 4, borderRadius: '8px', overflow: 'hidden' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs 
                value={value} 
                onChange={handleChange} 
                aria-label="archived records tabs"
                sx={{
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    minWidth: 120,
                    fontWeight: 600
                  }
                }}
              >
                <Tab label="Archived Clients" {...a11yProps(0)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <ArchivedClients />
            </TabPanel>
          </Paper>
        </div>
      </div>
    </div>
  );
}
